var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircularDeterminate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85938 7.14873L11.382 5.98036L13.0007 4.94915L14.7031 4.06294L16.4763 3.32847L18.3067 2.75134L20.1804 2.33594",
    stroke: "#D3B9BD",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8203 2.33594L29.694 2.75134L31.5244 3.32847L33.2976 4.06294L35 4.94915L36.6187 5.98036L38.1413 7.14873L39.5564 8.44536L40.853 9.86038L42.0213 11.383L43.0526 13.0017L43.9388 14.7041L44.6732 16.4773L45.2504 18.3077L45.6658 20.1814L45.9163 22.0843L46 24.0017L45.9163 25.9191L45.6658 27.822L45.2504 29.6957L44.6732 31.5262L43.9388 33.2993L43.0526 35.0017L42.0213 36.6204L40.853 38.143L39.5564 39.5581L38.1413 40.8547L36.6187 42.0231L35 43.0543L33.2976 43.9405L31.5244 44.6749L29.694 45.2521L27.8203 45.6675L25.9174 45.918L24 46.0017L22.0826 45.918L20.1797 45.6675L18.306 45.2521L16.4756 44.6749L14.7024 43.9405L13 43.0543L11.3813 42.0231L9.85867 40.8547L8.44365 39.5581L7.14702 38.143L5.97865 36.6204L4.94744 35.0017L4.06123 33.2993L3.32676 31.5262L2.74963 29.6957L2.33423 27.822L2.08372 25.9191L2 24.0017L2.08372 22.0843L2.33423 20.1814L2.74963 18.3077L3.32676 16.4773L4.06123 14.7041L4.94744 13.0017",
    stroke: "#A1626B",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularDeterminate);
export default __webpack_public_path__ + "static/media/circular-determinate.3f3b9f51672f8ceacc01553bb22a8077.svg";
export { ForwardRef as ReactComponent };